import { WSPage } from "@wingspanhq/fe-component-library";
import { RouteComponentProps } from "react-router-dom";
import { queriesPayees } from "@query";
import { WSQueries } from "../../../../../query/WSQuery";
import { useQueryRequirement } from "../../../../../query/requirements/queries/useQueryRequirement";
import { RequirementsDetailsRoute } from "./RequirementsDetailsRoute";
import { useBulkReviewRequirements } from "../../../../BulkReview/hooks/useBulkReviewRequirements";
import { useXWingspanPayerId } from "../useXWingspanPayerId";

export const RouteRequirementDetails: React.FC<
  RouteComponentProps<{
    payeeId: string;
    requirementId: string;
  }>
> = ({
  match: {
    params: { requirementId, payeeId }
  }
}) => {
  const xWingspanAccount = useXWingspanPayerId();
  const queryPayee = queriesPayees.getPayee.useQuery(
    { payeeId, xWingspanAccount },
    { staleTime: Infinity }
  );
  const queryRequirement = useQueryRequirement(requirementId, {
    staleTime: Infinity
  });

  useBulkReviewRequirements(requirementId);

  return (
    <WSPage>
      <WSQueries
        queries={{
          queryPayee,
          queryRequirement
        }}
      >
        {({ queryPayeeData, queryRequirementData }) => {
          return (
            <RequirementsDetailsRoute
              payee={queryPayeeData}
              requirement={queryRequirementData}
            />
          );
        }}
      </WSQueries>
    </WSPage>
  );
};
